import React from 'react';
import { useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Container } from '@mui/material';

import InfoWindow from '../../components/InfoWindow';

const ContractCancellationStatus = () => {
  const intl = useIntl();
  const { status } = useParams();

  return (
    <Container>
      {status === 'success' ? (
        <InfoWindow
          mode="success"
          titleHtml={intl.formatMessage({
            id: 'contract.cancellation.success.title',
          })}
          textHtml={null}
          button={{
            text: intl.formatMessage({
              id: 'contract.cancellation.success.button',
            }),
            href: '/',
            style: 'outlined',
          }}
        />
      ) : (
        <InfoWindow
          mode="failure"
          titleHtml={intl.formatMessage({
            id: 'contract.cancellation.failure.title',
          })}
          textHtml={intl.formatMessage({
            id: 'contract.cancellation.failure.text',
          })}
          buttons={[
            {
              text: intl.formatMessage({
                id: 'contract.cancellation.failure.button',
              }),
              href: '/contact',
              style: 'outlined',
            },
          ]}
        />
      )}
    </Container>
  );
};

export default ContractCancellationStatus;
